<template>
  <div class="p-2 rounded m-1" style="background-color: white;box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;" v-if="storeBasket.basketArray">
      <Transition name="slide-fade">
          <div style="max-height:250px" class="overflow-auto mb-1" v-if="ifListProduct">
            <div class="d-flex align-items-center w-100 pb-2" v-for="(bitem,index) in storeBasket.basketObject" :key="bitem.id" :class="{'bg-light' : (index+1)%2 ==0}">
                  <div  style="width:15%">
                    <img  :src="'https://radap.ir/' + bitem.img_url" width="50" height="50"  style="max-width: 35px;max-height: 40px;"/>
                  </div>
                  <div style="width:85%">
                      <span class="pt-2" style="max-height: 30px; font-size: 13px;">{{ bitem.name}}</span>
                      <footer class=" d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-wrap">
                          <del class="text-muted" style="margin-left: 5px;font-size: 14px;" v-if="bitem.discount > 0">{{convertToPersian(String(numberFormat(bitem.prime_price))) }}</del>
                          <strong style="margin-left: 5px; border: 1px solid red; border-radius: 5px; padding: 2px; color: red;font-size: 14px;" v-if="bitem.discount > 0"  :class="{ 'peculiar-discount': bitem.discount > 4 }">%{{convertToPersian(String(numberFormat(bitem.discount))) }}</strong>
                          <strong style="margin-left: 5px;font-size: 14px">{{ convertToPersian(String(numberFormat(bitem.price))) }}<small class="pr-1" style="font-size: 12px">تومان</small></strong>
                        </div>
                        <button-template :id="bitem.id" :sid="bitem.store_place_id" :quantity="bitem.quantity" origin="basket" @updated="getBasket"/>
                      </footer>
                  </div>
              </div>
          </div>
      </transition>
      <!-- چند فروشگاه -->
        <div class="d-flex justify-content-between align-items-center mb-1 px-1"> 
          <div class="m-0 w-80" style="font-size:14px;font-weight:700;letter-spacing: 0;">
            <div class="d-flex align-items-center">
              <span> فروشگاه</span>
              <div class="d-flex align-items-center w-75">
                  <span class="text-primary px-1 store-name">{{ storeBasket.supplierDetail.name }}</span> 
                  <div class="position-relative" v-if="storeBasket.basketArray && storeBasket.basketArray.length > 1">
                      <button class="btn bn-light px-1 p-0 border border-1" style="font-size:14px;font-weight:700" @click="ifListShop = !ifListShop">تغییر فروشگاه</button>
                      <Transition name="slide-fade">
                          <ul class="rounded p-1 " style="list-style: none;position:absolute;bottom:25px;background-color:white;max-width: 150px;" v-if="ifListShop">
                              <li class="pr-0 py-1 border-bottom" v-for="sitem in storeBasket.supplierList" :value="sitem.id" @click="ifListShop = !ifListShop,ifListProduct = false,storeBasket.setBasketSupplierID(sitem.id),storeBasket.getBasket()">{{ sitem.name }}</li>    
                          </ul>
                      </Transition>
                  </div>
              </div>
            </div>
          </div>
          <button class="btn bn-light p-0 w-20 text-end" style="font-size:12px;font-weight:700"  @click="ifListProduct = !ifListProduct,ifListShop = false">جزئیات <i class="fa fa-chevron-up"></i></button>

        </div>
        <div class="d-flex justify-content-between align-items-center px-1" v-if="storeBasket.basketArray"> 
          <span class ="d-block m-0 text-muted" style="font-size:12px;font-weight:700;letter-spacing: 0;">شما {{ convertToPersian(String(storeBasket.basketArray.length)) }} سبد خرید تسویه نشده دارید.</span>
        </div>
        <hr class="my-1" />
        <div class="d-flex justify-content-between align-items-center px-1" v-if="storeBasket.supplierDetail.minSale <= (parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount))">
          <div class="d-flex flex-column w-50" style="font-size:14px;font-weight:700;"><span class="text-center">مبلغ قابل پرداخت :</span><span class="text-center"> {{ convertToPersian(String(numberFormat((parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount)))))}} تومان</span></div>
          <button class="btn bg-success text-light w-50" @click="storeBasket.getBasketPopup()">ادامه خرید</button>
        </div> 
        <!-- حداقل خرید -->
        <div class="px-2 my-2" v-else >
          <div>
            <div class="d-flex justify-content-between px-1">
                <span class="d-block  m-0" style="font-size:14px;font-weight:700;letter-spacing: 0;">حداقل خرید : {{ convertToPersian(String(numberFormat(storeBasket.supplierDetail.minSale))) }} تومان</span>
                <span style="font-size:14px;font-weight:700;letter-spacing: 0;">باقی مانده : {{ convertToPersian(String(numberFormat(parseInt(storeBasket.supplierDetail.minSale) - (parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount)))))}} تومان</span>
            </div>
            <div class="progress my-1" style="height:10px;border-radius: 10px;padding:1px">
              <div class="progress-bar" role="progressbar" style="background-color: #f76868;border-radius: 10px" aria-valuemin="0" aria-valuemax="100" :style="{ width: ((parseInt(storeBasket.primeAmount) - parseInt(storeBasket.discount)) * 100) / parseInt(storeBasket.supplierDetail.minSale) + '%' }"></div>
            </div>
          </div>  
        </div>
  </div>
</template>
<script setup>
import {ref,reactive,computed} from 'vue'
import { useBasket } from '@/store/basket'
import ButtonTemplate from '../item/button.vue'
import { convertToPersian,numberFormat } from '@/composables/digits';
let ifListShop = ref(false)
let ifListProduct = ref(false)
const storeBasket = useBasket();
storeBasket.getSupplierNames()
storeBasket.getBasket()
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
.w-80{
  width: 80%;
}
.w-20{
  width: 20%;
}
@media (max-width : 420px){
  /* .w-80{
    width: 90%;
  }
  .w-20{
    width: 10%;
  } */
  .store-name{
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

::-webkit-scrollbar {
    width: 5px;
}
::-webkit-scrollbar-thumb {
    background: rgb(194, 191, 191);
    border-radius: 10px;
}


</style>